import styles from './Select.module.scss';

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  options: SelectOption[];
  value?: SelectOption;
  onChange: (option: SelectOption) => void;
  placeholder?: string;
  className?: string;
}

const Select = ({ 
  options, 
  value, 
  onChange, 
  placeholder = 'Select an option', 
  className = '' 
}: SelectProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = options.find(opt => opt.value === e.target.value);
    if (selectedOption) {
      onChange(selectedOption);
    }
  };

  return (
    <div className={`${styles.container} ${className}`}>
      <select
        className={styles.select}
        value={value?.value || ''}
        onChange={handleChange}
      >
        {!value && <option value="">{placeholder}</option>}
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <svg 
        className={styles.arrow} 
        width="10" 
        height="6" 
        viewBox="0 0 10 6" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M1 1l4 4 4-4" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Select; 